import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hoofdcategorie", "subcategorieSelect"];

  updateSubcategories() {
    const hoofdcategorieId = this.hoofdcategorieTarget.value;
    const oldSelect = this.subcategorieSelectTarget;
    const wrapper = oldSelect.closest(".form-select-wrapper");

    // Store currently selected subcategorie IDs before removing
    const selectedIds = Array.from(oldSelect.selectedOptions || []).map(
      (opt) => opt.value,
    );

    // remove old wrapper completely
    if (wrapper) {
      wrapper.remove(); // triggers disconnect for old tags controller
    }

    if (!hoofdcategorieId) {
      // If no hoofdcategorie selected, create empty select
      this.createEmptySubcategorieSelect(oldSelect);
      return;
    }

    fetch(
      `/organisatiesoorten/subcategorieen?hoofdcategorie_id=${encodeURIComponent(hoofdcategorieId)}`,
    )
      .then((response) => response.json())
      .then((data) => {
        // build new wrapper and select
        const newWrapper = document.createElement("span");
        newWrapper.className = "form-select-wrapper";

        const newSelect = document.createElement("select");
        newSelect.name = oldSelect.name;
        newSelect.id = oldSelect.id;
        newSelect.multiple = true;
        newSelect.className =
          "form-control dropdown form-select form-select-tags";
        newSelect.dataset.controller = "tags";
        newSelect.dataset.allowClear = "true";
        newSelect.dataset.suggestionsTreshold = "0";
        newSelect.dataset.organisatiesoortTarget = "subcategorieSelect";
        newSelect.setAttribute(
          "placeholder",
          " Selecteer een of meerdere subcategorieën",
        );

        // add new options
        data.forEach((subcat) => {
          const option = document.createElement("option");
          option.value = subcat.id;
          option.textContent = subcat.name;
          // Only restore selection if the subcategorie belongs to the new hoofdcategorie
          if (selectedIds.includes(subcat.id.toString())) {
            option.selected = true;
          }
          newSelect.appendChild(option);
        });

        newWrapper.appendChild(newSelect);

        // find the correct container
        const subcatRow = this.element
          .querySelector("label[for='subcategorieen']")
          ?.closest(".row");
        const subcatCol = subcatRow?.querySelector(".col-sm-8");
        const targetCol = subcatCol || this.element;

        // append new wrapper in the right visual spot
        targetCol.appendChild(newWrapper);
      });
  }

  createEmptySubcategorieSelect(oldSelect) {
    const newWrapper = document.createElement("span");
    newWrapper.className = "form-select-wrapper";

    const newSelect = document.createElement("select");
    newSelect.name = oldSelect.name;
    newSelect.id = oldSelect.id;
    newSelect.multiple = true;
    newSelect.className = "form-control dropdown form-select form-select-tags";
    newSelect.dataset.controller = "tags";
    newSelect.dataset.allowClear = "true";
    newSelect.dataset.suggestionsTreshold = "0";
    newSelect.dataset.organisatiesoortTarget = "subcategorieSelect";
    newSelect.setAttribute(
      "placeholder",
      "Selecteer eerst een type organisatie",
    );
    newSelect.setAttribute("disabled", true);

    newWrapper.appendChild(newSelect);

    const subcatRow = this.element
      .querySelector("label[for='subcategorieen']")
      ?.closest(".row");
    const subcatCol = subcatRow?.querySelector(".col-sm-8");
    const targetCol = subcatCol || this.element;

    targetCol.appendChild(newWrapper);
  }
}
